import * as pako from "pako";
import { useNotepadStore } from "@/features/notepad/store/useNotepadStore";
import { CanvasChunkType, makeCanvasChunk } from "./chunk_protocol";

/**
 * Shared helpers for canvas chunks that ride the notepad's persistent WS
 * outside the request/stream lifecycle (client metrics).
 */

/**
 * Ship a CanvasChunk directly on the shared canvas WS (zlib-compressed, per
 * useCanvasRuntimeBridge pattern). Returns false when the WS is not open.
 */
export function sendSharedCanvasChunk(
  chunkType: CanvasChunkType,
  chunkData: string,
  turnId = "",
): boolean {
  const ws = useNotepadStore.getState().notepadWs;
  if (!ws || ws.readyState !== WebSocket.OPEN) return false;
  const chunk = makeCanvasChunk(chunkType, chunkData, turnId);
  const compressed = pako.deflate(
    new TextEncoder().encode(JSON.stringify(chunk)),
  );
  ws.send(compressed);
  return true;
}
